// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popover-content::-webkit-scrollbar{width:0}.popover-content::-webkit-scrollbar-thumb{background:transparent;border-radius:10px}.popover-content:hover::-webkit-scrollbar{width:5px}.popover-content:hover::-webkit-scrollbar-thumb{background:var(--colors-gray-400)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
